import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { IMAGES } from '../data';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full items-end overflow-hidden" data-id="element-95" data-mp="ehtm248snfri">
      <img src={IMAGES.heroEvening} alt="Dukat långbord i en småländsk trädgård i skymningsljus med levande ljus och gäster som skrattar" className="absolute inset-0 h-full w-full object-cover" data-id="element-96" data-mp="9ipc3be1pe04" />
      <div className="absolute inset-0 bg-gradient-to-t from-brun/80 via-brun/25 to-brun/40" data-id="element-97" data-mp="xanoxzt57hfd" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 pb-16 md:px-10 md:pb-24" data-id="element-98" data-mp="sbb57nxkiqh0">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6 text-[12px] uppercase tracking-wide3 text-warm/70" data-id="element-99" data-mp="nc89iu3h9wlp">
          Handplockat i Småland
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: 'easeOut'
      }} className="font-display text-5xl font-light leading-[0.98] text-warm sm:text-6xl md:text-7xl lg:text-8xl" data-id="element-100" data-mp="3j8ixl0k6uiv8">
          Smaken som Baken
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: 'easeOut'
      }} className="mt-6 font-display text-xl italic text-warm/85 md:text-2xl" data-id="element-101" data-mp="3e8ecex8c4zyo">
          All mat. Alla smaker. Samlat i Småland.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.35,
        ease: 'easeOut'
      }} className="mt-7 max-w-xl text-base leading-relaxed text-warm/80 md:text-lg" data-id="element-102" data-mp="2qhqudj4pgtye">
          Smålands handplockade marknadsplats för mat, fika och dryck där smak, kvalitet och
          hantverk alltid står i centrum.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.5,
        ease: 'easeOut'
      }} className="mt-10" data-id="element-103" data-mp="nbbdp0t5cf6c">
          <a href="#verksamheter" className="group inline-flex items-center gap-3 rounded-full bg-warm px-9 py-4 text-sm uppercase tracking-wide2 text-brun transition-colors hover:bg-skog hover:text-warm" data-id="element-104" data-mp="ddf082cql852">
            Utforska smaker
            <ArrowDownIcon className="h-4 w-4 transition-transform group-hover:translate-y-0.5" data-id="element-105" data-mp="15zzubakljycb" />
          </a>
        </motion.div>
      </div>
    </section>;
}